import React from 'react';
import './styles.scss';
import { ReactComponent as RemoveIcon } from 'assets/icons/close.svg';

type Props = {
  text: string;
  showDeleteIcon?: boolean;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const Chip = (props: Props) => {
  const { text, showDeleteIcon, onClick } = props;

  return (
    <button className='chip' onClick={(e) => onClick?.(e)}>
      {text}
      {showDeleteIcon ? (
        <span className='chip__remove'>
          <RemoveIcon />
        </span>
      ) : null}
    </button>
  );
};

export default Chip;
